import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { Branch, CreateBranchRequest, UpdateBranchRequest, PagedResult } from '../types/api';

const BRANCHES_KEY = 'branches';

export function useBranches(pageNumber = 1, pageSize = 20) {
  return useQuery<PagedResult<Branch>>({
    queryKey: [BRANCHES_KEY, pageNumber, pageSize],
    queryFn: async () => {
      // تعديل الرابط ليكون /branches مباشرة بدون تكرار api
      const response = await api.get<Branch[]>('/branches');
      const branchesArray = Array.isArray(response.data) ? response.data : [];
      
      return {
        items: branchesArray,
        totalPages: 1,
        totalCount: branchesArray.length,
        pageNumber,
        pageSize,
        hasPreviousPage: false,
        hasNextPage: false
      } as any;
    },
  });
}

export function useBranch(id: number) {
  return useQuery<Branch>({
    queryKey: [BRANCHES_KEY, id],
    queryFn: async () => {
      const response = await api.get<Branch>(`/branches/${id}`);
      return response.data;
    },
    enabled: !!id,
  });
}

export function useCreateBranch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateBranchRequest) => {
      const response = await api.post('/branches', data);
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [BRANCHES_KEY] }),
  });
}

export function useUpdateBranch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: number; data: UpdateBranchRequest }) => {
      const response = await api.put(`/branches/${id}`, data);
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [BRANCHES_KEY] }),
  });
}

export function useDeleteBranch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
      const response = await api.delete(`/branches/${id}`);
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [BRANCHES_KEY] }),
  });
}
